import { render, staticRenderFns } from "./EditBanner.vue?vue&type=template&id=f5dc86da"
import script from "./EditBanner.vue?vue&type=script&lang=js"
export * from "./EditBanner.vue?vue&type=script&lang=js"
import style0 from "./EditBanner.vue?vue&type=style&index=0&id=f5dc86da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports